// src/PrivacyPolicy.js
// src/PrivacyPolicy.js
import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <h1>PRIVACY POLICY</h1>
        <p><strong>Updated on:</strong> July 29th, 2024</p>

        <p>
          Hive (“we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by Hive.
        </p>
        <p>
          This Privacy Policy applies to our app, and its associated subdomains (collectively, our “Service”) alongside our application, Hive. By accessing or using our Service, you signify that you have read, understood, and agree to our collection, storage, use, and disclosure of your personal information as described in this Privacy Policy and our Terms of Service.
        </p>

        <h2>Definitions and key terms</h2>
        <ul>
          <li><strong>Cookie:</strong> small amount of data generated by a website and saved by your web browser.</li>
          <li><strong>Company:</strong> refers to Hive, responsible for your information under this Privacy Policy.</li>
          <li><strong>Country:</strong> United Arab Emirates.</li>
          <li><strong>Customer:</strong> the entity using Hive services.</li>
          <li><strong>Device:</strong> any internet-connected device (phone, tablet, etc.).</li>
          <li><strong>IP address:</strong> used to identify device location online.</li>
          <li><strong>Personnel:</strong> employees or contractors of Hive.</li>
          <li><strong>Personal Data:</strong> identifiable user information.</li>
          <li><strong>Service:</strong> the Hive platform and related services.</li>
          <li><strong>Third-party service:</strong> advertisers, partners, and affiliates.</li>
          <li><strong>App/Application:</strong> Hive mobile app.</li>
          <li><strong>You:</strong> the person using Hive services.</li>
        </ul>

        <h2>What Information Do We Collect?</h2>
        <p>We collect data such as:</p>
        <ul>
          <li>Name / Username</li>
          <li>Phone Numbers</li>
          <li>Email Addresses</li>
          <li>Debit/Credit Card Numbers</li>
          <li>Age</li>
          <li>Password</li>
        </ul>
        <p>We may also collect optional mobile data:</p>
        <ul>
          <li>Location (GPS)</li>
          <li>Contacts list</li>
          <li>Camera access</li>
          <li>Photo gallery access</li>
        </ul>

        <h2>Use of Third-Party Information</h2>
        <p>We collect information shared via social media or third-party fraud detection tools to enhance service and security.</p>

        <h2>Sharing Information with Third Parties</h2>
        <p>
          We may share personal and non-personal data with trusted third parties for analytics, marketing, payment processing, legal compliance, and customer service.
        </p>

        <h2>How We Use Collected Information</h2>
        <ul>
          <li>To personalize your experience</li>
          <li>To improve our app and services</li>
          <li>To process transactions</li>
          <li>To send periodic emails</li>
        </ul>

        <h2>Email Usage</h2>
        <p>We use your email for communications, updates, and marketing, and you may unsubscribe anytime via provided links.</p>

        <h2>Data Retention</h2>
        <p>We retain data as long as necessary to provide services and comply with legal obligations.</p>

        <h2>Data Protection</h2>
        <p>
          Your data is secured using industry standards like SSL encryption, secure storage, and controlled access.
        </p>

        <h2>International Transfers</h2>
        <p>
          Your data may be transferred outside of your country, including to the UAE. By using our service, you consent to such transfers.
        </p>

        <h2>Data Security Limitations</h2>
        <p>We cannot guarantee absolute security despite our efforts and safeguards.</p>

        <h2>Accessing and Updating Your Information</h2>
        <p>
          You may update or delete your data by contacting us. Some records may remain in backups or logs.
        </p>

        <h2>Sale of Business</h2>
        <p>
          In case of a business transfer, your data may be transferred as part of the transaction.
        </p>

        <h2>Affiliates</h2>
        <p>
          We may share data with affiliated companies under the same privacy terms.
        </p>

        <h2>Governing Law</h2>
        <p>
          This Privacy Policy is governed by the laws of the United Arab Emirates.
        </p>

        <h2>Consent</h2>
        <p>
          By using Hive, registering, or making a purchase, you consent to this Privacy Policy.
        </p>

        <h2>Third-Party Links</h2>
        <p>
          We’re not responsible for content or policies of linked third-party websites or services.
        </p>

        <h2>Advertising</h2>
        <p>
          Hive may display ads or use cookies to serve targeted ads. We are not responsible for third-party ad content.
        </p>

        <h2>Cookies</h2>
        <p>
          We use cookies for functionality, analytics, and advertising. You can disable them in browser settings.
        </p>

        <h2>Remarketing</h2>
        <p>
          We may serve ads to users who have previously visited our app via remarketing strategies.
        </p>

        <h2>Payment Details</h2>
        <p>
          Payment data is stored securely and handled by trusted gateways. Sensitive data is not stored on our servers post-transaction.
        </p>

        <h2>Children's Privacy</h2>
        <p>
          We do not knowingly collect data from users under 13. If we discover such data, it will be deleted immediately.
        </p>

        <h2>Policy Changes</h2>
        <p>
          Changes to this policy will be notified through the app. Continued use after updates implies consent.
        </p>

        <h2>Third-Party Services Disclaimer</h2>
        <p>
          Hive disclaims responsibility for the accuracy or legality of third-party services or their data handling.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;




